import { render } from "./Chat.vue?vue&type=template&id=699a2fdb&scoped=true&ts=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=699a2fdb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699a2fdb"]])

export default __exports__